import getCustomCompsets from '@/utils/getCustomCompsets';
import getDestinations from '@/utils/getDestinations';
import useSectionState from '@/state/useSectionState';
import useDebugState from '@/state/useDebugState';

const { maxFreeCompsets } = useSectionState();
const { overrideCompsetsLimit } = useDebugState();

const checkCanCreateCompsets = async () => {
  if (overrideCompsetsLimit.value) {
    return true;
  }

  const [
    customCompsetsList,
    destinationsList,
  ] = await Promise.all([getCustomCompsets(), getDestinations()]);

  return [...customCompsetsList, ...destinationsList].length < maxFreeCompsets.value;
};

export default checkCanCreateCompsets;
